export const withAppData = (data: any = {}) => {
  return {
    ...data,
    app: 'fa-website',
  };
};
